(function ManagerClientProgramForm($, HE)
{
	"use strict";

	var form = {
		name: 'ClientProgram',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $enrolled_agents    = $('.enrolled-agents'),
		    $new_agent_template = $('.new-agent-template'),
		    empty_alert_exists  = $enrolled_agents.find('.alert'),
		    enrolled_agent_ids  = [];

		$enrolled_agents.find('input').each(function getEnrolledIds() {
			enrolled_agent_ids.push($(this).val());
		});

		$('#clientprogram-agent_default').on('change', function toggleDefaultProgram()
		{
			$('#clientprogram-active_dates').prop('disabled', this.checked);

			$('.default-program-notice').toggleClass('d-none', !this.checked);
			$('.no-enrolled-notice').toggleClass('d-none', this.checked);
			$('.enroll-agent').toggleClass('d-none', this.checked);
			$enrolled_agents.toggleClass('d-none', this.checked);
		});

		HE.Typeahead(
			'.existing-agent-search',
			'/Agents/search',
			function selectagent(agent, $self)
			{
				var $new_agent = $new_agent_template.clone();

				$new_agent.removeClass(['d-none', 'new-agent-template']);
				$new_agent.find('.name').html(agent.name);
				$new_agent.find('input').val(agent.id).removeAttr('disabled');

				$enrolled_agents.append($new_agent);

				if (empty_alert_exists) {
					empty_alert_exists.remove();
					empty_alert_exists = false;
				}

				$self.val('');
				enrolled_agent_ids.push(agent.id);
			},
			null,
			function filterEnrolledIds(agent) {
				return enrolled_agent_ids.indexOf(agent.id) === -1;
			}
		);
	};
}(jQuery, window.HE || {}));